import * as React from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { EmailTemplatesView } from "../publicPages/EmailTempletesView";

import closeIcon from '../assets/images/cross-close.svg';

const { useState, useEffect } = React;

export const EmailTempModel = ({ show, close, lang, scenario }) => {

    return (
        <>
            <Modal show={show} onHide={close} className="modalStyle p-0" size="lg">
                <Modal.Body className="p-5">
                    <div className="d-flex justify-content-end mb-4">
                        <img src={closeIcon} onClick={close} className="cursor-pointer" />
                    </div>
                    <EmailTemplatesView lang={lang} scenario={scenario}  />
                </Modal.Body>
            </Modal>
        </>
    )
} 
